import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=c944da48&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=js&"
export * from "./OrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=c944da48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c944da48",
  null
  
)

export default component.exports